import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  datePicker: {
    border: 'none',
    // '#f9f9f9' -> `tableHeaderBackground` ('#f5f5f5') and '#f0f0f0' ->
    // `hoverSurface` ('#EAEDED'); both are sub-perceptual shifts in light mode.
    backgroundColor: theme.palette.custom.tableHeaderBackground,
    padding: '8px',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.custom.hoverSurface,
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    padding: theme.spacing(3),
    '& .MuiPaper-root': {
      elevation: 3,
    },
    maxWidth: '100%',
  },
  title: {
    flexGrow: 1,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '200px',
  },
}));

export default useStyles;
